import request from '@/utils/request'

export default {
  // 单个查询
  LLZinfo () {
    return request({
      url: '/api/pc/llzdt/view-map',
      method: 'get'
      // data:
    })
  },
  // 获取绍兴市行政地区树
  Tree () {
    return request({
      url: '/api/system/area/xzdq/tree',
      method: 'get'
      // data:
    })
  },
  // 查询联络站列表
  llzList (data) {
    return request({
      url: '/api/app/wechat/llz/page',
      method: 'get',
      params: {
        ...data
      }
    })
  },
  // 查询联络站列表
  llzPublicList (data) {
    return request({
      url: '/api/app/wechat/llz/pageLlz',
      method: 'get',
      params: {
        ...data
      }
    })
  },
  // 征集详情列表查询
  getZjxqInfoOne (id, mobile) {
    return request({
      url: '/api/all/votea/detail',
      method: 'get',
      params: { id, mobile }
    })
  },
  // 获取手机验证码
  getPhoneCode (mobile) {
    return request({
      url: '/api/app/sms/code/get',
      method: 'get',
      params: { mobile }
    })
  },
  // 验证验证码
  checkCode (mobile, smsCode) {
    return request({
      url: '/api/app/sms/code/check',
      method: 'get',
      params: { mobile, smsCode }
    })
  },
  // 查询历史建议
  getHistoryJy (data) {
    return request({
      url: '/api/app/xmyjzjqz/page',
      method: 'get',
      params: {
        ...data
      }
    })
  },
  // 添加选民意见征集群众留言
  addChancePeopleText (data) {
    return request({
      url: '/api/all/voteresult/qrcode/insert',
      method: 'POST',
      data
    })
  },
  // 查询联络站代表列表
  llzDBList (data) {
    return request({
      url: '/api/app/wechat/llzdb/page',
      method: 'get',
      params: {
        ...data
      }
    })
  },
  // 选民历史留言
  getHistory (openid) {
    return request({
      url: '/api/app/wechat/user/xmly/page',
      method: 'get',
      params: {
        openid
      }
    })
  },
  // 获取代表信息
  // 获取详情信息
  getDetail (id) {
    return request({
      url: `/api/pc/dbllz/view-db/${id}`,
      method: 'GET'
    })
  },
  // 获取详情信息
  getPublicDbInfo (id) {
    return request({
      url: `/api/pc/dbllz/viewSensitive-db/${id}`,
      method: 'GET'
    })
  },
  // 获取联络站详情信息
  getLlzDetail (id) {
    return request({
      url: `/api/pc/dbllz/view/${id}`,
      method: 'GET'
    })
  },
  // 联络站分页查询
  getSerchPage (llzName) {
    return request({
      url: '/api/pc/dbllz/page',
      method: 'GET',
      params: { llzName }
    })
  },
  // 获取数据字典
  getDataDic (code) {
    return request({
      url: '/api/common/data-dic/list',
      method: 'GET',
      params: { code }
    })
  },
  // /api/app/wechat/user/view/xmyj-info/
  // 根据用户标识及代表ID查询意见建议填写信息
  getUserInfo (data) {
    return request({
      url: '/api/app/wechat/user/view/xmyj-info/',
      method: 'GET',
      params: { ...data }
    })
  },

  // /api/app/xmyj/tjxmly
  // 群众-添加选民留言
  addPeopleText (data) {
    return request({
      url: '/api/app/xmyj/tjxmly',
      method: 'POST',
      data
    })
  },
  // 选民留言详情
  contextDetail (id) {
    return request({
      url: `/api/app/wechat/user/view/xmly/${id}`,
      method: 'GET'
    })
  },
  // 意见征集列表
  getColectList (pageIndex, pageSize, styles) {
    return request({
      url: '/api/all/votea/page',
      method: 'get',
      params: { pageIndex, pageSize, styles }
    })
  }
}
